/* eslint no-template-curly-in-string: 0 */
import targetLogo from "../../assets/images/target-logo.png";
import targetGiftCard from "../../assets/images/target-gift-card.png";
import { FLOW_TYPES, PAYMENT_STATUSES } from "../../utils/enums";

const css = {
  // ":root": {
  //   "--btn-primary-bg-color": "red",
  //   "--btn-primary-bg-color-hover": "red",
  //   "--btn-primary-font-color": "#fff",
  //   "--btn-primary-font-color-hover": "#fff"
  // },
};

const aboutNetworkFaq = {
  answer: "Target GiftCards let you shop for thousands of items at more than 1,700 Target stores in the U.S. and online at Target.com. From toys to electronics and clothing to housewares, find exactly what you’re looking for at Target. They’re the rewarding choice.<br/><br/>Redeemable for merchandise or services (other than gift cards and prepaid cards) at Target stores in the U.S. or Target.com, and cannot be redeemed for cash or credit except where required by law. No value until purchased. For balance information, visit Target.com/giftcards or call <a href=\"tel:+1-800-544-2943\">1-800-544-2943</a>. To replace the remaining value on a lost, stolen or damaged card with the original purchase receipt, call <a href=\"tel:+1-800-544-2943\">1-800-544-2943</a>. ©2018 Target Brands, Inc. The Bullseye Design and Target are registered trademarks of Target Brands, Inc. The Bullseye Design, Target and Target GiftCards are registered trademarks of Target Brands, Inc. Terms and conditions are applied to Gift Cards. Target is not a participating partner in or sponsor of this offer.",
  question: "About Target® eGiftCard"
};

export const target = {
  id: "EGIFT_BLACKHAWK_TARGET",
  displayName: "Target eGiftCard",
  paymentFlow: "email",
  paywall: {
    tile: {
      displayName: "Target eGiftCard™",
      tagline: "Use online or in-store",
      description: [
        {
          string: "Immediate funds to buy your favorite",
          type: "div",
        },
        {
          string: "items, gifts, and more",
          type: "div",
        },
      ],
      // btnLabel: "Next",
      logo: targetLogo
    }
  },
  recipientLogin: {
    flow: FLOW_TYPES.RECIPIENT_LOGIN.AUTO_LOGIN,
    loading: {
      title: "Preparing your Target eGiftCard™"
    }
  },
  acceptPayment: {
    css,
    flow: FLOW_TYPES.ACCEPT_PAYMENT.AUTO_ACCEPT,
    btnLabel: "GET MY TARGET CARD",
    description: [
      "You have chosen to receive a ",
      {
        string: "${payment.amount}",
        transformations: [
          {
            type: "formatAsCurrency",
            data: {
              currency: "${payment.currency}"
            }
          }
        ],
        props: {
          className: "payment-amount",
        }
      },
      " Target eGiftCard which will be emailed to ",
      {
        string: "${payment.recipientEmail}.",
        props: {
          className: 'payment-recipientEmail',
        }
      }
    ],
    imgSrc: targetGiftCard
  },
  networkSelectionAccepted: {
    imgSrc: targetGiftCard,
  },
  paymentComplete: {
    initial: {
      description: [
        "Success! Please check your email ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail',
          },
        },
        " for details regarding your ",
        {
          string: "Target eGiftCard™",
          props: {
            className: 'payment-paymentNetwork',
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    revisit: {
      description: [
        "An email was sent to ",
        {
          string: "${payment.recipientEmail}",
          props: {
            className: 'payment-recipientEmail'
          },
        },
        " on ",
        {
          string: "${payment.updatedAt}",
          props: {
            className: 'payment-updatedAt'
          },
          transformations: [
            {
              type: "formatDate"
            }
          ],
        },
        " with details regarding your ",
        {
          string: "Target eGiftCard™",
          props: {
            className: 'payment-paymentNetwork'
          }
        },
        " for ",
        {
          string: "${payment.acceptedAmount}",
          transformations: [
            {
              type: "formatAsCurrency",
              data: {
                currency: "${payment.acceptedCurrency}"
              }
            }
          ],
          props: {
            className: "payment-amount",
          }
        },
        ".",
      ],
      secondaryText: "Please treat this card like cash and care for it accordingly to avoid loss or theft.",
    },
    imgSrc: targetGiftCard,
  },
  faqs: {
    byPaymentStatus: {
      [PAYMENT_STATUSES.PENDING_ACCEPTANCE]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.ACCEPTED]: [
        aboutNetworkFaq
      ],
      [PAYMENT_STATUSES.COMPLETE]: [
        aboutNetworkFaq
      ]
    }
  },
  onHold: {
    imgSrc: targetGiftCard,
    description: 'Your payment selection has been received. In most cases, funds are instantly sent; however in some instances it can take 24 to 48 hours for money to arrive.',
  }
};

export default target;
